<div class="m-2">
    <mat-card>
        <mat-card-content>
            <div style="display: flex; flex-direction: row-reverse; gap: 8px;">
                <div style="display: flex; gap: 8px;">
                    <button mat-raised-button color="primary" (click)="openSendEmailBottomSheet()"
                        [disabled]="isLoading">
                        Send an Email
                    </button>
                    <button mat-raised-button color="primary" (click)="getEmails()" [disabled]="isLoading">
                        <mat-icon *ngIf="isLoading">refresh</mat-icon>
                        Refresh
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="mt-4">
        <mat-card-content>
            <!-- State display component -->
            <app-state-display *ngIf="showStateDisplay" [type]="stateType" loadingMessage="Loading emails..."
                emptyMessage="No emails sent" [errorMessage]="errorMessage || 'Failed to load emails'" emptyIcon="email"
                errorIcon="error_outline">
            </app-state-display>

            <!-- Emails table -->
            <table mat-table [dataSource]="dataSourceEmails" *ngIf="showTable">
                <ng-container matColumnDef="applicant">
                    <th mat-header-cell *matHeaderCellDef>Applicant</th>
                    <td mat-cell *matCellDef="let email">{{ Applicant.toDisplayText(email.applicant) }}</td>
                </ng-container>
                <ng-container matColumnDef="subject">
                    <th mat-header-cell *matHeaderCellDef>Subject</th>
                    <td mat-cell *matCellDef="let email">{{ email.subject }}</td>
                </ng-container>
                <ng-container matColumnDef="sender">
                    <th mat-header-cell *matHeaderCellDef>Sender</th>
                    <td mat-cell *matCellDef="let email">{{ email.senderName }}<br>{{ email.senderEmail }}</td>
                </ng-container>
                <ng-container matColumnDef="recipient">
                    <th mat-header-cell *matHeaderCellDef>Recipient</th>
                    <td mat-cell *matCellDef="let email">{{ email.recipientName }}<br>{{ email.recipientEmail }}</td>
                </ng-container>
                <ng-container matColumnDef="dateTime">
                    <th mat-header-cell *matHeaderCellDef>Date time</th>
                    <td mat-cell *matCellDef="let email">{{ DateUtil.formatDate(email.createdAt) }}</td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let email">{{ ApplicationEmailStatus.toDisplayText(email.status) }}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let email;index as i;">
                        <button mat-button color="primary" (click)="viewEmail(email)">View</button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsEmails"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsEmails"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>